import { RouteObject } from 'react-router-dom';
import RequireAuth from '~/components/auth/RequireAuth';
import { RoutesEnum } from '~/constants/enums';
import Activities from '~/modules/activities';
import Favorites from '~/modules/activities/pages/Favorites';

export const activitiesRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <RequireAuth>
        <Activities />
      </RequireAuth>
    ),
    children: [
      {
        path: RoutesEnum.FAVORITES,
        element: <Favorites />,
      },
    ],
  },
];
